<div class="header__wrapper">
  <div class="header__upper" [ngClass]="{ 'reverse': !headerService.isNavigationBackVisible() }">
    <a (click)="navigateBack()" *ngIf="headerService.isNavigationBackVisible()">
      <img class="navigate-back" alt="menu logo" src="{{ARROW_LEFT_WHITE}}" />
    </a>
    <a class="header--left" (click)="navigateToHome()">
      <img alt="menu logo" src="{{LOGO}}" class="img__logo" />
    </a>
    <div id="coinBalanceDiv" class="header--right">
      <img src="{{MBC_FRONT_SIDE}}" alt="" class="mbc-coin">
      <div class="coins__number--wrapper">
        <p id="coinsBalanceText" class="coins__number">{{ $mbcBalance | async | number:'1.0-0':'de-DE'}}</p>
      </div>
    </div>
  </div>

  <app-activities-tabs [className]="'nav-bar'"
    *ngIf="this.headerService.isActivitiesTabsVisible()"></app-activities-tabs>

  <app-history-tabs [className]="'nav-bar'" *ngIf="this.headerService.isHistoryTabsVisible()"></app-history-tabs>
  <app-vouchers-tabs [className]="'betting-nav-bar'"
    *ngIf="this.headerService.isVoucherTabsVisible()"></app-vouchers-tabs>
  <app-free-to-play-tabs [className]="'betting-nav-bar'"
    *ngIf="this.headerService.isFreeToPlayTabsVisible()"></app-free-to-play-tabs>
  <app-jackpot-tabs [className]="'betting-nav-bar'"
    *ngIf="this.headerService.isJackpotTabsVisible()"></app-jackpot-tabs>
  <app-betting-tasks-tabs [className]="'betting-nav-bar'"
    *ngIf="this.headerService.isBettingTasksTabsVisible()"></app-betting-tasks-tabs>

  <div class="header" *ngIf="headerService.currentNavBar" [className]="'header'">
    <div class="header-icon-wrapper">
      @if(headerService.currentNavBar.imageURL){
      <img src="{{headerService.currentNavBar.imageURL}}" class="header-icon">
      }
      {{headerService.currentNavBar.title}}
    </div>
    <button class="btn header-info" (click)="openInfoModal()" *ngIf="headerService.currentNavBar.hasInfo">
      <img alt="info Logo" class="header-info-img" src="{{INFO_WHITE}}" />
    </button>
  </div>
</div>